document.addEventListener('DOMContentLoaded', () => {
  const heroRoot = document.querySelector('[data-hero-slideshow]');
  if (heroRoot) {
    const slides = heroRoot.querySelectorAll('.hero__slide, .hp-hero-slide');
    let current = 0;

    if (slides.length > 1) {
      window.setInterval(() => {
        slides[current].classList.remove('is-active', 'active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active', 'active');
      }, 12000);
    }
  }

  const toggle = document.querySelector('[data-mobile-nav-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });

    mobileNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  const promoPopup = document.querySelector('[data-promo-popup]');
  if (promoPopup && !sessionStorage.getItem('promoPopupDismissed')) {
    const delay = Number(promoPopup.dataset.delay || 2000);
    const showPopup = () => {
      promoPopup.classList.add('is-visible');
      promoPopup.setAttribute('aria-hidden', 'false');
    };

    window.setTimeout(showPopup, delay);

    promoPopup.querySelectorAll('[data-promo-close], [data-promo-accept]').forEach((element) => {
      element.addEventListener('click', () => {
        promoPopup.classList.remove('is-visible');
        promoPopup.setAttribute('aria-hidden', 'true');
        sessionStorage.setItem('promoPopupDismissed', 'true');
      });
    });
  }

  const secretBar = document.querySelector('[data-secret-bar]');
  if (secretBar) {
    const track = secretBar.querySelector('[data-secret-track]');
    const secretReveal = secretBar.querySelector('[data-secret-reveal]');
    const threshold = Number(secretBar.dataset.secretThreshold || 120);
    const velocityThreshold = Number(secretBar.dataset.secretVelocity || 900);
    const secretLink = secretBar.dataset.secretLink || '/pages/secret-room';
    let dragging = false;
    let startX = 0;
    let baseTranslate = 0;
    let currentTranslate = 0;
    let lastSample = null;
    let unlocked = false;

    const getTranslateX = (element) => {
      const computed = window.getComputedStyle(element);
      const transform = computed.transform;
      if (!transform || transform === 'none') return 0;
      const match = transform.match(/matrix.*\((.+)\)/);
      if (!match) return 0;
      const values = match[1].split(',').map(Number);
      return values.length === 6 ? values[4] : values[12] || 0;
    };

    const openSecret = () => {
      window.location.href = secretLink;
    };

    const resetTicker = () => {
      dragging = false;
      secretBar.classList.remove('is-dragging', 'is-paused');
      track.style.animation = '';
      track.style.transform = '';
    };

    const startDrag = (clientX) => {
      dragging = true;
      startX = clientX;
      baseTranslate = getTranslateX(track);
      currentTranslate = baseTranslate;
      lastSample = { x: clientX, time: Date.now() };
      unlocked = secretBar.classList.contains('is-unlocked');
      secretBar.classList.add('is-paused', 'is-dragging');
      track.style.animation = 'none';
      track.style.transform = `translateX(${baseTranslate}px)`;
    };

    const moveDrag = (clientX) => {
      if (!dragging) return;
      const delta = clientX - startX;
      currentTranslate = Math.max(baseTranslate - 40, Math.min(baseTranslate + 180, baseTranslate + delta));
      track.style.transform = `translateX(${currentTranslate}px)`;
      if (currentTranslate - baseTranslate >= threshold) {
        secretBar.classList.add('is-unlocked');
        unlocked = true;
      }
      lastSample = { x: clientX, time: Date.now() };
    };

    const endDrag = (clientX) => {
      if (!dragging) return;
      const now = Date.now();
      const delta = clientX - startX;
      const velocity = lastSample ? ((clientX - lastSample.x) / Math.max(now - lastSample.time, 1)) * 1000 : 0;
      const fastEnough = delta > threshold * 0.65 && velocity > velocityThreshold;

      if (fastEnough) {
        openSecret();
        return;
      }

      if (!unlocked) {
        secretBar.classList.remove('is-unlocked');
        resetTicker();
      } else {
        dragging = false;
        secretBar.classList.remove('is-dragging');
        secretBar.classList.add('is-paused', 'is-unlocked');
      }
    };

    secretBar.addEventListener('pointerdown', (event) => {
      if (secretBar.classList.contains('is-unlocked') && event.target.closest('[data-secret-reveal]')) {
        return;
      }
      startDrag(event.clientX);
      secretBar.setPointerCapture(event.pointerId);
    });

    secretBar.addEventListener('pointermove', (event) => {
      moveDrag(event.clientX);
    });

    secretBar.addEventListener('pointerup', (event) => {
      endDrag(event.clientX);
    });

    secretBar.addEventListener('pointercancel', resetTicker);
    secretBar.addEventListener('mouseenter', () => {
      secretBar.classList.add('is-paused');
    });
    secretBar.addEventListener('mouseleave', () => {
      if (!dragging && !secretBar.classList.contains('is-unlocked')) {
        secretBar.classList.remove('is-paused');
      }
    });

    if (secretReveal) {
      secretReveal.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openSecret();
      });
    }
  }

  const neonSequence = document.querySelector('[data-neon-sequence]');
  if (neonSequence) {
    const poster = neonSequence.querySelector('[data-neon-poster]');
    const hotspots = neonSequence.querySelectorAll('[data-secret-step]');
    const feedback = neonSequence.querySelector('[data-neon-feedback]');
    const status = neonSequence.querySelector('[data-neon-status]');
    const successLink = neonSequence.dataset.successLink || '/pages/prize-wheel';
    const clickedGuards = new Set();
    let stage = 0;

    const setFeedback = (message, state) => {
      if (!feedback) return;
      feedback.textContent = message;
      feedback.classList.remove('is-error', 'is-success');
      if (state) feedback.classList.add(state);
    };

    const setStatus = (message) => {
      if (status) status.textContent = message;
    };

    const glitchPoster = (className) => {
      if (!poster) return;
      poster.classList.remove('is-glitch', 'is-error');
      void poster.offsetWidth;
      poster.classList.add(className);
      window.setTimeout(() => poster.classList.remove(className), 450);
    };

    const resetSequence = () => {
      stage = 0;
      clickedGuards.clear();
      hotspots.forEach((hotspot) => hotspot.classList.remove('is-hit'));
      setStatus('Stand by. The sequence is waiting.');
      setFeedback('Find the order hidden in the frame.', '');
    };

    const completeSequence = () => {
      hotspots.forEach((hotspot) => hotspot.classList.add('is-hit'));
      setStatus('Circuit complete. Prize wheel incoming.');
      setFeedback('Sequence solved. The poster is melting open.', 'is-success');
      if (poster) {
        poster.classList.add('is-melting');
      }
      window.setTimeout(() => {
        window.location.href = successLink;
      }, 1200);
    };

    hotspots.forEach((hotspot) => {
      hotspot.addEventListener('click', () => {
        const step = hotspot.dataset.secretStep;
        let correct = false;

        if (stage < 2 && (step === 'guard-a' || step === 'guard-b')) {
          if (!clickedGuards.has(step)) {
            clickedGuards.add(step);
            hotspot.classList.add('is-hit');
            stage = clickedGuards.size;
            setStatus(stage === 1 ? 'First guard lit. Find the second.' : 'Two guards lit. Find the rider.');
            setFeedback(stage === 1 ? 'One gate block is active.' : 'The frame is charged. Click the surfer.', '');
            glitchPoster('is-glitch');
            correct = true;
          }
        } else if (stage === 2 && step === 'surfer') {
          hotspot.classList.add('is-hit');
          stage = 3;
          setStatus('The rider is live. Finish on the waves.');
          setFeedback('One rider in the sun. Now hit the TEC SURF text.', '');
          glitchPoster('is-glitch');
          correct = true;
        } else if (stage === 3 && step === 'waves') {
          hotspot.classList.add('is-hit');
          completeSequence();
          correct = true;
        }

        if (!correct) {
          setStatus('Wrong order. The circuit reset.');
          setFeedback('The poster flashed red. Start with the two left-side gate blocks.', 'is-error');
          glitchPoster('is-error');
          window.setTimeout(resetSequence, 260);
        }
      });
    });
  }

  const wheelRoot = document.querySelector('[data-secret-wheel]');
  if (wheelRoot) {
    const button = document.querySelector('[data-secret-wheel-spin]');
    const disc = wheelRoot.querySelector('[data-secret-wheel-disc]');
    const result = document.querySelector('[data-secret-wheel-result]');
    const emailInput = document.querySelector('[data-secret-wheel-email]');
    const claimButton = document.querySelector('[data-secret-wheel-claim]');
    const lockNote = document.querySelector('[data-secret-wheel-lock-note]');
    const resetInput = document.querySelector('[data-secret-wheel-reset-input]');
    const resetButton = document.querySelector('[data-secret-wheel-reset-button]');
    const claimModal = document.querySelector('[data-secret-wheel-claim-modal]');
    const claimModalTitle = document.querySelector('[data-secret-wheel-claim-title]');
    const claimModalNote = document.querySelector('[data-secret-wheel-claim-note]');
    const claimPhoneInput = document.querySelector('[data-secret-wheel-phone]');
    const claimCodeInput = document.querySelector('[data-secret-wheel-code]');
    const claimSendButton = document.querySelector('[data-secret-wheel-send-code]');
    const claimVerifyButton = document.querySelector('[data-secret-wheel-verify-code]');
    const claimCloseButtons = document.querySelectorAll('[data-secret-wheel-claim-close]');
    const prizes = (wheelRoot.dataset.prizes || '').split('|').filter(Boolean);
    const claimApiBase = (wheelRoot.dataset.claimApiBase || '').replace(/\/$/, '');
    let spinning = false;
    let spinsRemaining = 0;
    let rotation = 0;
    let pendingPrize = '';
    let pendingClaimId = '';
    let spinSessionId = '';

    const cookieSet = (name, value, days) => {
      const expires = new Date(Date.now() + days * 86400000).toUTCString();
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
    };

    const cookieGet = (name) => {
      const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
      return match ? decodeURIComponent(match[1]) : '';
    };

    const fingerprint = [
      navigator.userAgent,
      navigator.language,
      window.screen.width,
      window.screen.height,
      Intl.DateTimeFormat().resolvedOptions().timeZone
    ].join('|');

    const digest = (value) => {
      let hash = 0;
      for (let i = 0; i < value.length; i += 1) {
        hash = ((hash << 5) - hash) + value.charCodeAt(i);
        hash |= 0;
      }
      return String(Math.abs(hash));
    };

    const deviceKey = `secretWheelDevice:${digest(fingerprint)}`;
    const emailKeyFor = (email) => `secretWheelEmail:${digest(email.trim().toLowerCase())}`;

    const readLock = () => {
      const local = localStorage.getItem(deviceKey);
      const cookie = cookieGet(deviceKey);
      if (!local && !cookie) return null;
      try {
        return JSON.parse(local || cookie);
      } catch {
        return null;
      }
    };

    const writeLock = (payload) => {
      const serialized = JSON.stringify(payload);
      localStorage.setItem(deviceKey, serialized);
      cookieSet(deviceKey, serialized, 120);
      if (payload.email) {
        localStorage.setItem(emailKeyFor(payload.email), serialized);
        cookieSet(emailKeyFor(payload.email), serialized, 120);
      }
    };

    const lockFromEmail = (email) => {
      const local = localStorage.getItem(emailKeyFor(email));
      const cookie = cookieGet(emailKeyFor(email));
      if (!local && !cookie) return null;
      try {
        return JSON.parse(local || cookie);
      } catch {
        return null;
      }
    };

    const clearLock = (email) => {
      localStorage.removeItem(deviceKey);
      cookieSet(deviceKey, '', -1);
      if (email) {
        const emailKey = emailKeyFor(email);
        localStorage.removeItem(emailKey);
        cookieSet(emailKey, '', -1);
      }
    };

    const setLockedState = (payload) => {
      spinsRemaining = 0;
      if (button) {
        button.disabled = true;
        button.textContent = 'Spin locked';
      }
      if (claimButton) {
        claimButton.disabled = true;
      }
      if (emailInput) {
        emailInput.disabled = true;
      }
      if (result && payload?.displayText) {
        result.textContent = payload.displayText;
      } else if (result && payload?.prize) {
        result.textContent = `Already claimed: ${payload.prize}`;
      } else if (result) {
        result.textContent = 'This browser has already used its official spin.';
      }
      if (lockNote) {
        lockNote.textContent = 'This browser has already completed its official prize claim.';
      }
    };

    const setPendingClaimState = (payload) => {
      spinsRemaining = 0;
      pendingPrize = payload?.prize || pendingPrize;
      if (button) {
        button.disabled = false;
        button.textContent = 'Finish claim';
      }
      if (claimButton) {
        claimButton.disabled = true;
      }
      if (emailInput) {
        emailInput.disabled = true;
      }
      if (result && payload?.prize) {
        result.textContent = `Pending claim: ${payload.prize}. Verify your phone to receive the code.`;
      }
      if (lockNote) {
        lockNote.textContent = 'Your spin is locked in. Finish the phone verification to claim your prize.';
      }
    };

    const setClaimNote = (message) => {
      if (claimModalNote) claimModalNote.textContent = message;
    };

    const renderClaimResult = (payload) => {
      if (!result) return;

      const parts = [`Claimed: ${payload.prizeLabel}.`];
      if (payload.rewardCode) {
        parts.push(`Code: ${payload.rewardCode}.`);
      }
      if (payload.rewardType === 'internal_access_code' && payload.accessUrl) {
        parts.push(`VIP link: ${payload.accessUrl}`);
      } else if (payload.rewardType === 'manual_fulfillment_code') {
        parts.push('Save this code and we can honor it manually.');
      }
      if (payload.emailDelivery?.skipped) {
        parts.push('Email sender is not configured yet, so this prize was shown on-screen only.');
      }

      result.textContent = parts.join(' ');
    };

    const openClaimModal = (prize) => {
      pendingPrize = prize;
      pendingClaimId = '';
      spinSessionId = `spin_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
      if (claimModalTitle) claimModalTitle.textContent = `Claim ${prize}`;
      if (claimPhoneInput) claimPhoneInput.value = '';
      if (claimCodeInput) claimCodeInput.value = '';
      setClaimNote('Enter your phone number to receive a one-time verification code.');
      if (claimModal) {
        claimModal.classList.add('is-visible');
        claimModal.setAttribute('aria-hidden', 'false');
      }
    };

    const closeClaimModal = () => {
      if (claimModal) {
        claimModal.classList.remove('is-visible');
        claimModal.setAttribute('aria-hidden', 'true');
      }
    };

    const postJson = async (path, body) => {
      const response = await fetch(`${claimApiBase}${path}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(payload.error || 'Request failed.');
      }
      return payload;
    };

    const existingLock = readLock();
    if (existingLock?.claimPending) {
      setPendingClaimState(existingLock);
    } else if (existingLock) {
      setLockedState(existingLock);
    }

    if (button && disc && prizes.length) {
      if (claimButton && emailInput && !existingLock) {
        claimButton.addEventListener('click', () => {
          const email = (emailInput.value || '').trim().toLowerCase();
          if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            if (result) result.textContent = 'Enter a valid email to unlock your official spin.';
            return;
          }

          const priorEmailLock = lockFromEmail(email);
          if (priorEmailLock) {
            setLockedState(priorEmailLock);
            return;
          }

          spinsRemaining = 1;
          button.disabled = false;
          claimButton.disabled = true;
          emailInput.disabled = true;
          if (result) result.textContent = 'Spin unlocked. One official spin is ready.';
          if (lockNote) lockNote.textContent = 'Your email and browser have been marked for one official spin. Bonus Spin grants exactly one extra try.';
        });
      }

      button.addEventListener('click', () => {
        if (!spinning && spinsRemaining < 1 && pendingPrize) {
          openClaimModal(pendingPrize);
          return;
        }

        if (spinning || spinsRemaining < 1) return;
        spinning = true;
        spinsRemaining -= 1;
        button.disabled = true;
        const index = Math.floor(Math.random() * prizes.length);
        const sliceAngle = 360 / prizes.length;
        rotation += 360 * 5 + (360 - (index * sliceAngle + sliceAngle / 2));
        disc.style.transform = `rotate(${rotation}deg)`;
        result.textContent = 'The tide is choosing...';

        window.setTimeout(() => {
          const prize = prizes[index];
          if (prize.toLowerCase() === 'bonus spin') {
            spinsRemaining += 1;
            result.textContent = `You landed on: ${prize}. You earned one extra spin.`;
            button.disabled = false;
            writeLock({ email: emailInput ? emailInput.value.trim().toLowerCase() : '', prize, spinsRemaining, bonusGranted: true });
          } else {
            result.textContent = `You landed on: ${prize}. Claim steps are open.`;
            writeLock({
              email: emailInput ? emailInput.value.trim().toLowerCase() : '',
              prize,
              spinsRemaining: 0,
              bonusGranted: false,
              claimPending: true
            });
            setPendingClaimState({ prize });
            if (claimApiBase) {
              openClaimModal(prize);
            }
          }
          spinning = false;
          if (spinsRemaining > 0) {
            button.textContent = 'Spin again';
          } else {
            button.textContent = 'Spin complete';
          }
        }, 4400);
      });
    }

    if (claimSendButton && claimPhoneInput) {
      claimSendButton.addEventListener('click', async () => {
        const email = emailInput ? emailInput.value.trim().toLowerCase() : '';
        const phone = claimPhoneInput.value.trim();
        if (!email) {
          setClaimNote('Enter your email first to unlock the wheel.');
          return;
        }
        if (!phone) {
          setClaimNote('Enter a valid phone number first.');
          return;
        }
        if (!pendingPrize) {
          setClaimNote('Spin the wheel first so we know which prize to claim.');
          return;
        }
        if (!claimApiBase) {
          setClaimNote('Claim API base URL is missing in theme settings.');
          return;
        }

        claimSendButton.disabled = true;
        setClaimNote('Sending verification code...');

        try {
          const payload = await postJson('/api/claims/start', {
            spinSessionId,
            email,
            phone,
            prizeLabel: pendingPrize,
            fingerprint
          });
          pendingClaimId = payload.claimId;
          setClaimNote('Code sent. Enter the SMS code to finalize your prize.');
        } catch (error) {
          setClaimNote(error.message);
        } finally {
          claimSendButton.disabled = false;
        }
      });
    }

    if (claimVerifyButton && claimCodeInput) {
      claimVerifyButton.addEventListener('click', async () => {
        const verificationCode = claimCodeInput.value.trim();
        if (!pendingClaimId) {
          setClaimNote('Send the phone verification code first.');
          return;
        }
        if (!verificationCode) {
          setClaimNote('Enter the verification code from the SMS.');
          return;
        }

        claimVerifyButton.disabled = true;
        setClaimNote('Verifying and issuing your reward...');

        try {
          const payload = await postJson('/api/claims/verify', {
            claimId: pendingClaimId,
            verificationCode
          });
          writeLock({
            email: emailInput ? emailInput.value.trim().toLowerCase() : '',
            prize: payload.prizeLabel,
            spinsRemaining: 0,
            bonusGranted: false,
            claimPending: false,
            rewardCode: payload.rewardCode
          });
          renderClaimResult(payload);
          setClaimNote(
            payload.emailDelivery?.skipped
              ? `Prize claimed. Your code is ${payload.rewardCode}. Email sending is not configured yet, so save the code here.`
              : `Prize claimed. Your code is ${payload.rewardCode}.`
          );
          closeClaimModal();
          setLockedState({
            prize: payload.prizeLabel,
            displayText: result ? result.textContent : ''
          });
        } catch (error) {
          setClaimNote(error.message);
        } finally {
          claimVerifyButton.disabled = false;
        }
      });
    }

    claimCloseButtons.forEach((buttonEl) => {
      buttonEl.addEventListener('click', closeClaimModal);
    });

    if (resetButton && resetInput) {
      resetButton.addEventListener('click', async () => {
        const value = (resetInput.value || '').trim();
        if (value !== 'Waves21') return;
        const email = emailInput ? emailInput.value.trim().toLowerCase() : '';
        const phone = claimPhoneInput ? claimPhoneInput.value.trim() : '';

        if (claimApiBase) {
          try {
            await postJson('/api/claims/reset', {
              resetCode: value,
              email,
              phone
            });
          } catch (error) {
            if (result) result.textContent = error.message;
            return;
          }
        }

        clearLock(email);
        spinsRemaining = 1;
        rotation = 0;
        spinning = false;
        if (disc) disc.style.transform = 'rotate(0deg)';
        if (button) {
          button.disabled = false;
          button.textContent = 'Spin the wheel';
        }
        if (claimButton) claimButton.disabled = false;
        if (emailInput) emailInput.disabled = false;
        if (result) result.textContent = 'Reset accepted. Enter an email to unlock one fresh spin.';
        if (lockNote) lockNote.textContent = 'Reset key accepted for this session.';
        resetInput.value = '';
        closeClaimModal();
        pendingPrize = '';
        pendingClaimId = '';
      });
    }
  }

  const productBoard = document.querySelector('[data-product-board]');
  if (productBoard) {
    const variantInput = productBoard.querySelector('[data-product-variant-input]');
    const priceLabel = productBoard.querySelector('[data-product-price]');
    const submitButton = productBoard.querySelector('[data-product-submit]');
    const mainImage = productBoard.querySelector('[data-product-main-image]');
    const variantCards = productBoard.querySelectorAll('[data-variant-card]');
    const mediaThumbs = productBoard.querySelectorAll('[data-product-media-thumb]');
    const tabTriggers = productBoard.querySelectorAll('[data-product-tab-trigger]');
    const tabPanels = productBoard.querySelectorAll('[data-product-tab-panel]');
    const setImage = (url, alt) => {
      if (!mainImage || !url) return;
      mainImage.src = url;
      if (alt) mainImage.alt = alt;
    };

    variantCards.forEach((card) => {
      card.addEventListener('click', () => {
        variantCards.forEach((item) => item.classList.remove('is-active'));
        card.classList.add('is-active');

        if (variantInput) variantInput.value = card.dataset.variantId || '';
        if (priceLabel && card.dataset.variantPrice) {
          priceLabel.textContent = card.dataset.variantPrice;
        }

        const available = card.dataset.variantAvailable === 'true';
        if (submitButton) {
          submitButton.disabled = !available;
          submitButton.textContent = available ? 'Add to cart' : 'Sold out';
        }

        if (card.dataset.variantImage) {
          setImage(card.dataset.variantImage, card.dataset.variantImageAlt || '');
          mediaThumbs.forEach((thumb) => thumb.classList.remove('is-active'));
        }
      });
    });

    mediaThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        mediaThumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        setImage(thumb.dataset.mediaUrl, thumb.dataset.mediaAlt || '');
      });
    });

    tabTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const target = trigger.dataset.productTabTarget;
        tabTriggers.forEach((item) => item.classList.remove('is-active'));
        tabPanels.forEach((panel) => panel.classList.remove('is-active'));
        trigger.classList.add('is-active');
        const panel = productBoard.querySelector(`[data-product-tab-panel="${target}"]`);
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  document.querySelectorAll('[data-qty-control]').forEach((control) => {
    const input = control.querySelector('[data-qty-input]');
    const decrease = control.querySelector('[data-qty-decrease]');
    const increase = control.querySelector('[data-qty-increase]');
    const form = control.closest('[data-cart-form]');
    const updateButton = form ? form.querySelector('[data-cart-update]') : null;
    if (!input || !decrease || !increase) return;

    let submitTimeout = null;
    const submitCart = () => {
      if (!form || !updateButton) return;
      if (submitTimeout) window.clearTimeout(submitTimeout);
      submitTimeout = window.setTimeout(() => {
        form.requestSubmit(updateButton);
      }, 200);
    };

    decrease.addEventListener('click', () => {
      const current = Number(input.value || 0);
      input.value = Math.max(0, current - 1);
      submitCart();
    });

    increase.addEventListener('click', () => {
      const current = Number(input.value || 0);
      input.value = current + 1;
      submitCart();
    });

    input.addEventListener('change', () => {
      if (Number(input.value || 0) < 0) input.value = 0;
      submitCart();
    });
  });

  document.querySelectorAll('[data-product-qty-control]').forEach((control) => {
    const input = control.querySelector('[data-product-qty-input]');
    const decrease = control.querySelector('[data-product-qty-decrease]');
    const increase = control.querySelector('[data-product-qty-increase]');
    if (!input || !decrease || !increase) return;

    decrease.addEventListener('click', () => {
      const current = Number(input.value || 1);
      input.value = Math.max(1, current - 1);
    });

    increase.addEventListener('click', () => {
      const current = Number(input.value || 1);
      input.value = current + 1;
    });

    input.addEventListener('change', () => {
      if (Number(input.value || 1) < 1) input.value = 1;
    });
  });
});
